import { historyEntries } from '@/features/aboutHistory/data';
import type { AdminHistoryEntryDetail } from '@/features/content/types';
import { buildMockStorageKey, mockS3Prefixes } from '@/features/mock/storage';

const createPublishedAt = (year: number, index: number) => {
  const month = String((index % 12) + 1).padStart(2, '0');
  return `${String(year)}-${month}-01T09:00:00`;
};

export const createInitialMockHistoryEntries = (): AdminHistoryEntryDetail[] => {
  return historyEntries.map((entry, index) => {
    const imageFileName = buildMockStorageKey(
      mockS3Prefixes.historyImages,
      `${entry.id.replace(/^history-/, '')}.jpg`,
    );

    return {
      id: index + 1,
      year: entry.year,
      title: entry.subject,
      description: entry.description,
      imageUrl: entry.imageSrc ?? '',
      imageFileName,
      imageContentType: 'image/jpeg',
      imageFileSize: 0,
      imageFit: entry.imageFit ?? 'contain',
      imageObjectPosition: entry.imageObjectPosition ?? 'center center',
      imageScale: entry.imageScale ?? 1,
      displayOrder: index + 1,
      isPublished: true,
      publishedAt: createPublishedAt(entry.year, index),
    };
  });
};
